import React from 'react';
/** @type {import('../types').DataType<import('./types').ProjectBasicModel>} */

var PROJECT_NAME_DATA_TYPE = {
  extends: 'project',
  data: {
    url: '/backend/communicationsProjects',
    itemUrl: '/backend/communications?name={id}',
    dataKey: 'projectName',
    idKeyProp: 'Name'
  }
};
export default PROJECT_NAME_DATA_TYPE;